import { render, staticRenderFns } from "./zhuti.vue?vue&type=template&id=5ec7a72e&scoped=true&"
import script from "./zhuti.vue?vue&type=script&lang=ts&"
export * from "./zhuti.vue?vue&type=script&lang=ts&"
import style0 from "./zhuti.vue?vue&type=style&index=0&id=5ec7a72e&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ec7a72e",
  null
  
)

export default component.exports